import React, {useEffect} from 'react';
import Nav from '../../Page Components/Nav';
import Footer from "../../Page Components/Footer";
import Card from "../../Co Components/SquareCards";
import Square from "../../Co Components/SquareCards";
import Title from "../../Co Components/Titles";
import homehero from '../../assets/Images/homehero.png';
import Rectangle from "../../Co Components/RectangleCards";
import LineButton from "../../Co Components/LineButton";
import hackerRed from '../../assets/Images/hacker.png';
import BlogCard from "../../Co Components/BlogCards";
import HomeCard from "../../Co Components/HomeCards";
import PrimaryButton from "../../Co Components/PrimaryButton";
import SecondaryButton from "../../Co Components/SecondaryButton";
const RedTeam = () => {
useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>

            <Nav />
            <section className={' d-flex flex-row mt-0  align-items-center w-90 '}>
                <article>
                    <div className={'mx-5 w-75'}>
                        <h1 className={'bebas display-1 text-black bolde  line-normal'}>WhiteGuard
                            <span className={'bebas red'}><br /> Red Team Assessment</span><br />
                            Services</h1>
                    </div>

                    <div className={'w-75 mx-5'}>
                        <p className={'bolder h6'} >
                            Our Red Team use nondestructive methods to test
your ability to detect and respond to an active attacker scenario. The goal
of this service is to assess your security controls, prepare for future attacks,
mitigate the risk of costly security breaches, reduce your response time to
attacks and provide practical recommendations for improving your
security posture.
                        </p>
                    </div>
                </article>
                <figure className=' headerImage align-self-center d-flex flex-column w-25'>
                    <HomeCard className={'danger'} />
                    <img src={hackerRed} className={'hackerImage z-1'} />
                </figure>

            </section>

            <Title className={'mt-6'} header={"the"} body={"Benefits"} />
            <div className={'d-flex mb-5 flex-row justify-content-center align-items-center flex-wrap'}>
                <Square className={'mx-4 cardRed mt-5'} Title={"Assess and minimise"} text={'Assess and minimise attack surface'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"Comply"} text={'Comply with regulations and initiatives.'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"Develop"} text={'Develop remediation plans'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"Gauge"} text={'Gauge real-time response speed'}/>

                <Square className={'mx-4 cardRed mt-5'} Title={"Determine"} text={'Determine effectiveness of security awareness training'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"Reduce"} text={'Reduce potential downtime'} />
            </div>
            <Title className={'mt-6'} header={"the"} body={"Process"} />
            <div className={'d-flex mb-12 flex-column align-items-center justify-content-start process-container'} style={{ transition: 'all 0.3s ease' }}>
                <Rectangle className={'mt-4 cardRed'} Title={'Goal Setting'} text={'Customer asks the red team to determine if a threat agent can access specific assets.'} />
                <Rectangle className={'mt-4 cardRed'} Title={'Reconnaissance'} text={'Red team identifies network services, web applications, and employee portals.'} />
                <Rectangle className={'mt-4 cardRed'} Title={'Penetration Testing Exercise'} text={'Network service exploitation:'
                     +' Exploiting unpatched or \n' +
                    'misconfigured network services.\n' +
                    '\n Application layer exploitation: Web applications are often\n' +
                    'the first thing an attacker sees when looking at an organization’s\n' +
                    'network perimeter.'} />
                <Rectangle className={'mt-4 cardRed'} Title={'Phishing Exercise'} text={'Email and phone-based social engineering. With a little \n' +
                    'bit of research on individuals or organizations, phishing emails become a lot more convincing. This low hanging fruit is frequently the first in a\n' +
                    ' chain of composite attacks that lead to the goal.'} />
                <Rectangle className={'mt-4 cardRed'} Title={'Physical Exercise'} text={'Physical facility exploitation. People have a natural\n' +
                    'inclination to avoid confrontation. Thus, gaining access to a secure\n' +
                    'facility is often as easy as following someone through a door.'} />
            </div>


            <Footer />
        </>
    );

}

export default RedTeam;